import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { history } from "../../helpers";
import { contractReviewerConstants } from '../../constants';
import '../../content/css/ContractReviewer.css';
import { LoadingIcon } from '../LoadingIcon';
import { BackButton } from './BackButton';
import LoadingListener from '../../helpers/loadingListener';
import ContractTypePicker from '../Misc/ContractTypePicker';

export default class DocumentSettings extends Component {
    constructor(props) {
        super(props);

        this.loadingListener = new LoadingListener([contractReviewerConstants.EDIT_DOCUMENT_TYPE_REQUEST]);
    }

    getCurrentDocument() {
        let doc = this.props.analyzedDocuments[this.props.id];
        doc = doc ? doc : {
            highlights: [],
            missingHighlights: [],
            segments: []
        };

        return doc;
    }

    handleSelectType = (theme, hasChildren) => {
        if (this.props.id === "" || hasChildren) return;
        this.props.editDocumentType(this.props.id, theme.contractType);
        var self = this;
        setTimeout(function () {
            history.push(`/${self.props.id}`);
        }, 500);
    }

    handleClose = () => {
        history.push(`/${this.props.match.params.docId}`);
    }

    render() {
        let doc = this.getCurrentDocument();
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div className="settings">
                {isLoading &&
                    <LoadingIcon />
                }

                {!isLoading &&
                    <React.Fragment>
                        <Row>
                            {!this.props.hideBackButton &&
                                <BackButton to={`/${this.props.match.params.docId}`} />
                            }
                        </Row>
                        <ContractTypePicker selectedType={doc.contractType} onSelect={this.handleSelectType} />
                    </React.Fragment>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/DocumentSettings.js